module.exports = __webpack_public_path__ + "img/by.9b2f3e1e.svg";